let $pwreset = $('#pwdreset-form');

let validator = $pwreset.validate({
    rules: {
        password: "required",
        password_confirmation: {
            equalTo: "#password"
        },
    },
    highlight: function (element) {
        $(element).closest('.input-line').addClass('has-error');
    },
    unhighlight: function (element) {
        $(element).closest('.input-line').removeClass('has-error');
    },
    messages: {
        password: "Поле обязательно для заполнения",
        password_confirmation: {
            required: "Поле обязательно для заполнения",
            equalTo: "Пароли не совпадают",
        },
    },
});

$pwreset.on('submit', function(e) {

    if (validator.valid()) {
        e.preventDefault();
        oc.progressBar.show();
        oc.request(this, 'ResetPassword::onAjax', {
            success: function(response) {
                oc.progressBar.hide();
                if (!response) {
                    return;
                }

                var redirect = (response.$env && response.$env.getRedirectUrl()) || response['X_OCTOBER_REDIRECT']; // jshint ignore:line
                if (redirect) {
                    window.location = redirect;
                    return;
                }

                if (!response.status) {
                    oc.flashMsg({message: response.message, class: 'flash-message-error'});
                }
            }
        });
        return false;
    }

});
